module.exports = __webpack_public_path__ + "static/media/universe.e2bbb247.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/universe.jpg
// module id = 763
// module chunks = 1 3